import { render, staticRenderFns } from "./LanguageRepeater.vue?vue&type=template&id=2405ef78&scoped=true&"
import script from "./LanguageRepeater.vue?vue&type=script&lang=js&"
export * from "./LanguageRepeater.vue?vue&type=script&lang=js&"
import style0 from "./LanguageRepeater.vue?vue&type=style&index=0&id=2405ef78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405ef78",
  null
  
)

export default component.exports